class DillerV2Controller extends AbstractIntegrationController
	@register()
	@inject '$filter',
		'configuration'
		'configurationOptions'
		'IntegrationRepository'
		'Shops'
		'CountryService'
		'UserInformation'
		'ToastService'
		'translate'

	integrationId: 'diller_v2'

	initialize: ->
		if _.isEmpty(@configuration.shops)
			@configuration.shops = {}

		if _.isEmpty(@configuration.store_id)
			@setTextButtonTextToNext()

		@isNew = @configuration.is_active != true

		@shops = _.map @Shops.data, (shop) =>
			shopConfiguration = @configuration.shops[shop.id]
			shop.is_selected = shopConfiguration?

			return shop

		@defaultDistributorId = @UserInformation.getMasterUser().distributor?.id

		@tabs = [
			{
				title: 'wbo.integration.diller_v2.credentials'
				selector: '#tab-credentials'
				form: 'vm.mainForm.credentials'
			}
			{
				title: 'wbo.integration.diller_v2.recruitment',
				selector: '#tab-recruitment'
				form: 'vm.mainForm.recruitment'
			}
		]

		@recruitment = @getEmptyRecruitmentFormData()

	afterDisconnect: ->
		@configuration = {}

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data
				@isNew = false

				if _.isEmpty(@configuration.shops)
					@configuration.shops = {}

				if _.isEmpty(@configuration.store_id)
					@setTextButtonTextToNext()
				else
					delete @saveButtonText

				@updateConfigurationOptions()

	afterDisconnect: ->
		@configuration = {}
		@isNew = true
		@setTextButtonTextToNext()

	addShop: (shop) ->
		shop.is_selected = true

		@mainForm.$setDirty()

	removeShop: (shop) ->
		shop.is_selected = false

		delete @configuration.shops[shop.id]

		@mainForm.$setDirty()

	updateConfigurationOptions: ->
		@IntegrationRepository
			.getConfigurationOptions @integrationId
			.then (response) =>
				@configurationOptions = response.data

	setTextButtonTextToNext: ->
		@saveButtonText = 'general.next'

	getEmptyRecruitmentFormData: ->
		return {
			basic_information: {}
			contact_information: {}
			billing_information: {}
			partner_information: {
				distributor_id: @defaultDistributorId
			}
		}

	onRecruitmentButtonClick: () ->
		@IntegrationRepository
			.run(@integrationId, @recruitment, 'recruitment')
			.then () =>
				@recruitment = @getEmptyRecruitmentFormData()
				@mainForm.recruitment.$setPristine()
				@mainForm.recruitment.$setUntouched()
				@ToastService
					.add(
						null,
						@translate('wbo.integration.diller_v2.recruitment_email'),
						@translate('alert.sent'),
						'success',
					)
			.catch (response) =>
				@handleErrors(response.data)
				@ToastService.showErrors(response.data, @translate('wbo.integration.diller_v2.recruitment_email'))
